import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DashboardHeader from '../components/DashboardHeader';
import ApplicationsTable from '../components/ApplicationsTable';
import { db } from '../firebase';
import { collection, getDocs, query, orderBy } from "firebase/firestore";

function DashboardPage() {
  const [applications, setApplications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchApplications = async () => {
      setIsLoading(true);
      try {
        const q = query(collection(db, "applications"), orderBy("createdAt", "desc"));
        const querySnapshot = await getDocs(q);
        const appsList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setApplications(appsList);
      } catch (error) {
        console.error("Error fetching applications: ", error);
        alert("Could not fetch applications.");
      }
      setIsLoading(false);
    };

    fetchApplications();
  }, []);

  return (
    <>
      {/* <DashboardHeader /> */}
      <div className="flex-1 p-4 md:p-6 lg:p-8">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="flex flex-col gap-1">
            <p className="text-3xl font-black leading-tight tracking-[-0.033em] text-header-text">
              MDRO Dashboard
            </p>
            <p className="text-base font-normal leading-normal text-text-color/70">
              Overview of all applications.
            </p>
          </div>
          <div className="flex gap-2">
            <Link
              to="/new-application"
              className="flex h-10 min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-lg bg-primary px-4 text-sm font-bold leading-normal tracking-[0.015em] text-white hover:bg-hover-color"
            >
              <span className="material-symbols-outlined text-base">add</span>
              <span className="truncate">New Application</span>
            </Link>
          </div>
        </div>

        <ApplicationsTable applications={applications} isLoading={isLoading} />
      </div>
    </>
  );
}

export default DashboardPage;